var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerminatedTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7425_62968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 10.45C12.2148 10.45 13.1998 9.46508 13.1998 8.25005C13.1998 7.03502 12.2148 6.05005 10.9998 6.05005C9.78478 6.05005 8.7998 7.03502 8.7998 8.25005C8.7998 9.46508 9.78478 10.45 10.9998 10.45Z",
    stroke: "#B0394D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0498 15.95C6.0498 12.9124 8.2085 10.45 10.9998 10.45C11.6048 10.45 12.1823 10.56 12.7048 10.7635",
    stroke: "#B0394D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 13.2L17.0502 17.05",
    stroke: "#B0394D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0502 13.2L13.2002 17.05",
    stroke: "#B0394D",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7425_62968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminatedTagIcon);
export default __webpack_public_path__ + "static/media/TerminatedTagIcon.8a62420019fc99f7d72fd7a89655bffc.svg";
export { ForwardRef as ReactComponent };